var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-chart',{attrs:{"header":("" + _vm.documentTitle),"options":_vm.chartMSNOptions,"series":_vm.chartMSNSeries,"chartId":"msn","chartRedirectParams":_vm.chartRedirectParams,"chartLoading":_vm.chartLoading,"chartError":_vm.chartError}})}
var staticRenderFns = []

export { render, staticRenderFns }